"use client";

import React, {
  createContext,
  useState,
  useContext,
  useEffect,
} from "react";

import { BASE_URL } from "../config/apiConfig";

export const AuditLogContext = createContext();

export const AuditLogProvider = ({ children }) => {
  const [auditLogs, setAuditLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Get token from localStorage
  const getToken = () => localStorage.getItem("token");

  // Safe JSON parser
  const parseJson = async (response) => {
    try {
      return await response.json();
    } catch {
      return null;
    }
  };

  // Fetch all audit logs
  const fetchAuditLogs = async () => {
    setLoading(true);
    setError("");

    try {
      const token = getToken();

      const res = await fetch(`${BASE_URL}/audit-logs`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) {
        const data = await parseJson(res);

        setError(
          data?.message || "Failed to fetch audit logs"
        );

        return;
      }

      const data = await parseJson(res);

      if (!data) {
        setError("Invalid server response");
        return;
      }

      if (data.status === 200) {
        setAuditLogs(data.data || []);
      } else {
        setError(
          data.message || "Failed to fetch audit logs"
        );
      }
    } catch (err) {
      console.error(err);

      setError("Error fetching audit logs");
    } finally {
      setLoading(false);
    }
  };

  // Fetch on load
  useEffect(() => {
    const token = getToken();

    if (token) {
      fetchAuditLogs();
    }
  }, []);

  return (
    <AuditLogContext.Provider
      value={{
        auditLogs,
        loading,
        error,
        fetchAuditLogs,
      }}
    >
      {children}
    </AuditLogContext.Provider>
  );
};

export const useAuditLogs = () =>
  useContext(AuditLogContext);